import { useState } from 'preact/hooks';
import { getService, setService, createService } from '@/services';
import { divExists } from '@/rules';
import Box from './Box';

function forceShow({ serviceName, useQuerySelectorAll, key, domain, divName }) {
	//init service if it doesnt exist yet
	if (!getService(serviceName)) {
		setService(serviceName, createService(serviceName));
	}
	const service = getService(serviceName);
	service.start(() => {
		const renderDiv = divExists(divName) ? divName : document.body;
		service.openForm({
			key,
			domain,
			divName: renderDiv,
			useQuerySelectorAll,
			triggerMethod: 'force',
		});
	});
}

export default function ShowAnyway({ rule = {}, survey = {}, toggleDrawer = () => {} }) {
	const [clicked, setClicked] = useState(false);
	const { service: serviceName = 'mopinion', useQuerySelectorAll, args = [] } = rule.then[0];
	const [key, domain, divName] = args;

	const disableEmbedded = survey.formType === 'Embedded' && !divExists(divName);

	const handleClick = () => {
		setClicked(true);
		forceShow({
			serviceName,
			useQuerySelectorAll,
			key,
			domain,
			divName,
		});

		if (survey.formType === 'Slide-in' && ['right', 'bottom-right'].indexOf(survey.sliderPosition) !== -1) {
			toggleDrawer();
		}
	};

	return (
		<Box>
			<Box
				component="button"
				name="show-anyway"
				classes={['btn-link']}
				onClick={handleClick}
				disabled={disableEmbedded}
			>
				Force show
			</Box>
			{disableEmbedded && (
				<Box name="embedded-alert">You can only force show an embedded form if the rendering element is present</Box>
			)}
		</Box>
	);
}
